import { API } from '@/shared/api/modules';
import type { GetRevenuePerUnitRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getRevenuePerResidentScopedQueryOptions = (
  params: GetRevenuePerUnitRequestDto
) =>
  queryOptions({
    queryKey: ['revenue-per-resident-scoped', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getRevenuePerResidentScoped(params, { signal }),
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });

export const getRevenuePerBedQueryOptions = (
  params: GetRevenuePerUnitRequestDto
) =>
  queryOptions({
    queryKey: ['revenue-per-bed', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getRevenuePerBedScoped(params, { signal }),
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });
